module.exports = __webpack_public_path__ + "static/media/unicef.3995e634.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/unicef.png
// module id = 881
// module chunks = 0